import Vue from "vue"
import Vuetify from "vuetify"

Vue.use(Vuetify)

//Load Plugins
export default new Vuetify({
	options: {
		customProperties: true
	},
	icons: {
		iconfont: "mdi"
	},
	theme: {
		dark: true,
		themes: {
			dark: {
				primary: "#212121",
				secondary: "#353535", // '#8597c3',
				accent: "#96b3eb",
				error: "#ff4d2e", // WCAG AA compliant: 4.70:1 contrast ratio
				warning: "#f87b00", // Already compliant: 4.93:1 contrast ratio
				info: "#5abff0", // WCAG AA compliant: 5.84:1 contrast ratio
				success: "#aad79b"
			}
		}
	}
})
